module.exports = __webpack_public_path__ + "img/zoeweb-play.944ec858.jpeg";